const initialState = {

    //JV Details
    loadingJVDetails: false,
    JVDetails: {},
    JVDetailsError: '',

    //Companies LiST
    loadingJVLedgerAccountList: false,
    JVLedgerAccountList: [],
    JVLedgerAccountListError: '',



    //Branch master LiST
    loadingBranchMasterList: false,
    BranchMasterList: [],
    BranchMasterListError: '',


    //Cost center LiST
    loadingCostCenterList: false,
    CostCenterList: [],
    CostCenterListError: '',
    
    //currency master LIST
    loadingCurrencyMasterList: true,
    CurrencyMasterList: [],
    CurrencyMasterListError: '',



    //JV List
    loadingJournelVoucherList: true,
    JournelVoucherList: [],
    JournelVoucherListError: '',
    JournelVoucherListCurrentPage: 0,
    JournelVoucherListTotalPage: 0,
    JournelVoucherListTotalData: 0


}

const JournelVoucherReducer = (state = initialState, action) => {
    switch (action.type) {


        //JV Details//
        case 'FIND_JOURNEL_VOUCHER_DETAILS_REQUEST':
            return {
                ...state,
                loadingJVDetails: true,
                JVDetails: {},
                JVDetailsError: '',
            };
        case 'FIND_JOURNEL_VOUCHER_DETAILS_SUCCESS':
            return {
                ...state,
                loadingJVDetails: false,
                JVDetails: action.payload.data,

            };
        case 'FIND_JOURNEL_VOUCHER_DETAILS_FAILURE':
            return {
                ...state,
                loadingJVDetails: false,
                JVDetailsError: action.payload,
            };
        //JV Details//

        //Companies LiST//
        case 'FIND_LEDGER_ACCOUNT_LIST_REQUEST':
            return {
                ...state,
                loadingJVLedgerAccountList: true,
                JVLedgerAccountList: [],
                JVLedgerAccountListError: '',
            };
        case 'FIND_LEDGER_ACCOUNT_LIST_SUCCESS':
            return {
                ...state,
                loadingJVLedgerAccountList: false,
                JVLedgerAccountList: action.payload.data,

            };
        case 'FIND_LEDGER_ACCOUNT_LIST_FAILURE':
            return {
                ...state,
                loadingJVLedgerAccountList: false,
                JVLedgerAccountListError: action.payload,
            };
        //Companies LiST//

        //Branch Master LiST//
        case 'FIND_BRANCH_MASTER_LIST_REQUEST':
            return {
                ...state,
                loadingBranchMasterList: true,
                BranchMasterList: [],
                BranchMasterListError: '',
            };
        case 'FIND_BRANCH_MASTER_LIST_SUCCESS':
            return {
                ...state,
                loadingBranchMasterList: false,
                BranchMasterList: action.payload.data,

            };
        case 'FIND_BRANCH_MASTER_LIST_FAILURE':
            return {
                ...state,
                loadingBranchMasterList: false,
                BranchMasterListError: action.payload,
            };
        //Branch Master LiST//

        //Cost Center LiST//
        case 'FIND_COST_CENTER_LIST_REQUEST':
            return {
                ...state,
                loadingCostCenterList: true,
                CostCenterList: [],
                CostCenterListError: '',
            };
        case 'FIND_COST_CENTER_LIST_SUCCESS':
            return {
                ...state,
                loadingCostCenterList: false,
                CostCenterList: action.payload.data,

            };
        case 'FIND_COST_CENTER_LIST_FAILURE':
            return {
                ...state,
                loadingCostCenterList: false,
                CostCenterListError: action.payload,
            };
        //Cost Center LiST//

        //Currency Master LiST//
        case 'FIND_CURRENCY_MASTER_LIST_REQUEST':
            return {
                ...state,
                loadingCurrencyMasterList: true,
                CurrencyMasterList: [],
                CurrencyMasterListError: '',
            };
        case 'FIND_CURRENCY_MASTER_LIST_SUCCESS':
            return {
                ...state,
                loadingCurrencyMasterList: false,
                CurrencyMasterList: action.payload.data,

            };
        case 'FIND_CURRENCY_MASTER_LIST_FAILURE':
            return {
                ...state,
                loadingCurrencyMasterList: false,
                CurrencyMasterListError: action.payload,
            };
        //Currency Master LiST//

        //JournelVoucher List//
        case 'FIND_JOURNEL_VOUCHER_LIST_REQUEST':
            return {
                ...state,
                loadingJournelVoucherList: true,
                JournelVoucherList: [],
                JournelVoucherListError: '',
                JournelVoucherListCurrentPage: 0,
                JournelVoucherListTotalPage: 0,
                JournelVoucherListTotalData: 0,
            };
        case 'FIND_JOURNEL_VOUCHER_LIST_SUCCESS':
            return {
                ...state,
                loadingJournelVoucherList: false,
                JournelVoucherList: action.payload.data,
                JournelVoucherListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                JournelVoucherListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                JournelVoucherListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_JOURNEL_VOUCHER_LIST_FAILURE':
            return {
                ...state,
                loadingJournelVoucherList: false,
                JournelVoucherListError: action.payload,
                JournelVoucherListCurrentPage: 1,
                JournelVoucherListTotalPage: 0,
                JournelVoucherListTotalData: 0,
            };
        //JournelVoucher List//


        default:
            return state;
    }
}

export default JournelVoucherReducer;